export const RightLeftArrowIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      {...props}
    >
      <g>
        <path d="M2 6H22" />
        <path d="M22 18H2" />
        <path d="M17 11L22 6L17 1" />
        <path d="M7 23L2 18L7 13" />
      </g>
    </svg>
  );
};
